import Dispatcher from '../dispatcher';
import resolvePromise from '../helper/resolved_promise';
import FittingStationFinderAnalytics from '../../_modules/google_analytics/fitting_station_finder';

function openAction() {
    Dispatcher.handleLightboxAction({
        type: 'OPEN_LIGHTBOX',
    });
    FittingStationFinderAnalytics.sendOpenAction();

    return resolvePromise();
}

function closeAction() {
    Dispatcher.handleLightboxAction({
        type: 'CLOSE_LIGHTBOX',
    });

    return resolvePromise();
}

function goToPageAction(payload) {
    Dispatcher.handleLightboxAction({
        type: 'GOTO',
        payload,
    });

    return resolvePromise();
}

function nextAction() {
    Dispatcher.handleLightboxAction({
        type: 'GOTO_NEXT',
    });

    return resolvePromise();
}

function prevAction() {
    Dispatcher.handleLightboxAction({
        type: 'GOTO_PREV',
    });

    return resolvePromise();
}

function totalPagesChangeAction(payload) {
    Dispatcher.handleLightboxAction({
        type: 'TOTAL_PAGES_CHANGE',
        payload,
    });

    return resolvePromise();
}

const LightboxActions = {
    openAction: openAction,
    closeAction: closeAction,
    goToPageAction: goToPageAction,
    nextAction: nextAction,
    prevAction: prevAction,
    totalPagesChangeAction: totalPagesChangeAction,
};

export {
    openAction,
    closeAction,
    goToPageAction,
    nextAction,
    prevAction,
    totalPagesChangeAction
};

export default LightboxActions;
